/**
 * 导入导出
 * @author
 */
// import api from '@/services/api'
import {downFile,upFile, METHOD} from '@/utils/request'

export const dataApi = {
	async exportFile(url, result) {
		return downFile(url, METHOD.POST, result);
	},
	async importFile(url, file) {
		let param = new FormData();
		param.append("file",file)
		return upFile(url, METHOD.POST, param);
	},
}


export default {dataApi}